<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">ListGroup</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="row">
                    <!-- Simple List group -->
                    <div class="col-6 mb-5">
                        <b-list-group>
                            <b-list-group-item>Cras justo odio</b-list-group-item>
                            <b-list-group-item>Dapibus ac facilisis in</b-list-group-item>
                            <b-list-group-item>Morbi leo risus</b-list-group-item>
                            <b-list-group-item>Porta ac consectetur ac</b-list-group-item>
                            <b-list-group-item>Vestibulum at eros</b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- Active items -->
                    <div class="col-6 mb-5">
                        <b-list-group>
                            <b-list-group-item>Cras justo odio</b-list-group-item>
                            <b-list-group-item active>Dapibus ac facilisis in</b-list-group-item>
                            <b-list-group-item>Morbi leo risus</b-list-group-item>
                            <b-list-group-item>Porta ac consectetur ac</b-list-group-item>
                            <b-list-group-item>Vestibulum at eros</b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- Disabled items -->
                    <div class="col-6 mb-5">
                        <b-list-group>
                            <b-list-group-item disabled>Cras justo odio</b-list-group-item>
                            <b-list-group-item>Dapibus ac facilisis in</b-list-group-item>
                            <b-list-group-item>Morbi leo risus</b-list-group-item>
                            <b-list-group-item disabled>Porta ac consectetur ac</b-list-group-item>
                            <b-list-group-item>Vestibulum at eros</b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- Actionable list group items -->
                    <div class="col-6 mb-5">
                        <b-list-group>
                            <b-list-group-item href="#some-link">Awesome link</b-list-group-item>
                            <b-list-group-item href="#" active>Link with active state</b-list-group-item>
                            <b-list-group-item href="#">Action links are easy</b-list-group-item>
                            <b-list-group-item href="#foobar" disabled>Disabled link</b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- Button items -->
                    <div class="col-6 mb-5">
                        <b-list-group>
                            <b-list-group-item button>Button item</b-list-group-item>
                            <b-list-group-item button>I am a button</b-list-group-item>
                            <b-list-group-item button disabled>Disabled button</b-list-group-item>
                            <b-list-group-item button>This is a button too</b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- Contextual variants -->
                    <div class="col-6 mb-5">
                        <b-list-group>
                            <b-list-group-item>Default list group item</b-list-group-item>
                            <b-list-group-item variant="primary">Primary list group item</b-list-group-item>
                            <b-list-group-item variant="secondary">Secondary list group item</b-list-group-item>
                            <b-list-group-item variant="success">Success list group item</b-list-group-item>
                            <b-list-group-item variant="danger">Danger list group item</b-list-group-item>
                            <b-list-group-item variant="warning">Warning list group item</b-list-group-item>
                            <b-list-group-item variant="info">Info list group item</b-list-group-item>
                            <b-list-group-item variant="light">Light list group item</b-list-group-item>
                            <b-list-group-item variant="dark">Dark list group item</b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- Contextual variants -->
                    <div class="col-6 mb-5">
                        <b-list-group>
                            <b-list-group-item href="#">Default list group item</b-list-group-item>
                            <b-list-group-item href="#" variant="primary">Primary list group item</b-list-group-item>
                            <b-list-group-item href="#" variant="secondary">Secondary list group item</b-list-group-item>
                            <b-list-group-item href="#" variant="success">Success list group item</b-list-group-item>
                            <b-list-group-item href="#" variant="danger">Danger list group item</b-list-group-item>
                            <b-list-group-item href="#" variant="warning">Warning list group item</b-list-group-item>
                            <b-list-group-item href="#" variant="info">Info list group item</b-list-group-item>
                            <b-list-group-item href="#" variant="light">Light list group item</b-list-group-item>
                            <b-list-group-item href="#" variant="dark">Dark list group item</b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- With badges -->
                    <div class="col-6 mb-5">
                        <b-list-group>
                            <b-list-group-item class="d-flex justify-content-between align-items-center">
                                Cras justo odio
                                <b-badge variant="primary" pill>14</b-badge>
                            </b-list-group-item>

                            <b-list-group-item class="d-flex justify-content-between align-items-center">
                                Dapibus ac facilisis in
                                <b-badge variant="primary" pill>2</b-badge>
                            </b-list-group-item>

                            <b-list-group-item class="d-flex justify-content-between align-items-center">
                                Morbi leo risus
                                <b-badge variant="primary" pill>1</b-badge>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- With badges -->
                    <div class="col-12 mb-5">
                        <b-card-group deck>
                            <b-card header="Card with list group">
                                <b-list-group>
                                <b-list-group-item href="#">Cras justo odio</b-list-group-item>
                                <b-list-group-item href="#">Dapibus ac facilisis in</b-list-group-item>
                                <b-list-group-item href="#">Vestibulum at eros</b-list-group-item>
                                </b-list-group>

                                <p class="card-text mt-2">
                                Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla tempor. Laborum
                                consequat non elit enim exercitation cillum aliqua consequat id aliqua. Esse ex consectetur
                                mollit voluptate est in duis laboris ad sit ipsum anim Lorem.
                                </p>
                            </b-card>

                            <b-card no-body header="Card with flush list group">
                                <b-list-group flush>
                                <b-list-group-item href="#">Cras justo odio</b-list-group-item>
                                <b-list-group-item href="#">Dapibus ac facilisis in</b-list-group-item>
                                <b-list-group-item href="#">Vestibulum at eros</b-list-group-item>
                                </b-list-group>

                                <b-card-body>
                                Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla tempor. Laborum
                                consequat non elit enim exercitation cillum aliqua consequat id aliqua. Esse ex consectetur
                                mollit voluptate est in duis laboris ad sit ipsum anim Lorem.
                                </b-card-body>
                            </b-card>
                        </b-card-group>
                    </div>
                    <!-- Horizontal list groups -->
                    <div class="col-6 mb-5">
                        <b-list-group horizontal>
                            <b-list-group-item>Cras justo </b-list-group-item>
                            <b-list-group-item>Dapibus ac facilisis in</b-list-group-item>
                            <b-list-group-item>Morbi leo risus</b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- Horizontal at breakpoint md and above -->
                    <div class="col-6 mb-5">
                        <b-list-group horizontal="md">
                            <b-list-group-item>Cras justo</b-list-group-item>
                            <b-list-group-item>Dapibus ac facilisis in</b-list-group-item>
                            <b-list-group-item>Morbi leo risus</b-list-group-item>
                        </b-list-group>
                    </div>
                    <!-- Custom content -->
                    <div class="col-6 mb-5">
                        <b-list-group>
                            <b-list-group-item href="#" active class="flex-column align-items-start">
                                <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">List group item heading</h5>
                                    <small>3 days ago</small>
                                </div>
                                <p class="mb-1">
                                Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.
                                </p>
                                <small>Donec id elit non mi porta.</small>
                            </b-list-group-item>
                            <b-list-group-item href="#" class="flex-column align-items-start">
                                <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">List group item heading</h5>
                                    <small class="text-muted">3 days ago</small>
                                </div>
                                <p class="mb-1">
                                Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.
                                </p>
                                <small class="text-muted">Donec id elit non mi porta.</small>
                            </b-list-group-item>
                            <b-list-group-item href="#" disabled class="flex-column align-items-start">
                                <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">Disabled List group item</h5>
                                    <small class="text-muted">3 days ago</small>
                                </div>
                                <p class="mb-1">
                                Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.
                                </p>
                                <small class="text-muted">Donec id elit non mi porta.</small>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>
<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';

    import { Card } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {
                dismissSecs: 10,
                dismissCountDown: 0,
                showDismissibleAlert: false
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/ListGroup.vue